module.exports = __webpack_public_path__ + "assets/img/CalculatorBAIOS.9d0b4191.png";